




















import Vue from "vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwRentalIncome from "@/encoding/pages/questions/price/RentalIncome.vue";
import iwPercentageRented from "@/encoding/pages/questions/price/PercentageRented.vue";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
        iwAccordion: iwAccordion,
        iwPercentageRented: iwPercentageRented,
        iwRentalIncome: iwRentalIncome,
    },
    data: function () {
        return {
            pathInStore : "transaction.investor.isInvestmentProperty",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["CASTLE","FARMHOUSE","COUNTRY_COTTAGE","EXCEPTIONAL_PROPERTY","HOUSE","TOWN_HOUSE","MANSION","VILLA","OTHER_PROPERTY","MANOR_HOUSE","PAVILION","OFFICES","BUILDING","OFFICE_BLOCK","LARGE_TOWN_HOUSE","COMMERCIAL_VILLA","INDUSTRIAL_PREMISES","WAREHOUSE","BUSINESS","COMMERCIAL_PREMISES","HOTEL_RESTAURANT_CAFE","LOCK_UP_GARAGE","LOCK_UP_PARKING","OTHER","BED_N_BREAKFAST","GITES","CAMPSITE","HOLIDAY_PARK","BARGE","HOTEL","OTHER_HOUSE","BOAT_CRUISE","HOUSE_GROUP","APARTMENT_GROUP","APARTMENT_BLOCK","MIXED_USE_BUILDING","MIXED_USE_BUILDING_OFFICES","MIXED_USE_BUILDING_INDUSTRIES","MIXED_USE_BUILDING_COMMERCIAL"].indexOf(this.$store.getters["FormModule/getValue"]("property.subtype")) !== - 1;
        },

        isAutomatic: function(): boolean {
            return ["APARTMENT_BLOCK","MIXED_USE_BUILDING","MIXED_USE_BUILDING_OFFICES","MIXED_USE_BUILDING_INDUSTRIES","MIXED_USE_BUILDING_COMMERCIAL"].indexOf(this.$store.getters["FormModule/getValue"]("property.subtype")) !== -1;
        },

        isInvestmentProperty: {
            get: function(): boolean {
                return !!this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: this.isAutomatic ? true : value,
                });
            },
        },
    },

    mounted: function() {
        if (this.isAutomatic) {
            this.isInvestmentProperty = true;
        }
    },
});
